export const selectAccessCode = (state) => [state.accessCodeDefinition, state.setAccessCode]
